import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconUnlink2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, h, _, a) {
  return n(), d("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--unlink-2"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Unlink 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 4a2 2 0 1 0 0 4h1a.5.5 0 0 1 0 1h-1a3 3 0 1 1 0-6h1a.5.5 0 0 1 0 1h-1ZM7 3.5a.5.5 0 0 1 .5-.5h1a3 3 0 1 1 0 6h-1a.5.5 0 0 1 0-1h1a2 2 0 1 0 0-4h-1a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const g = /* @__PURE__ */ s(c, [["render", m]]);
export {
  g as default
};
//# sourceMappingURL=unlink-2.js.map
